var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "80%",
  height: "80%",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2.001 2.001 0 0 1 8 19.008z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy_icon.fc41e7b03e5bcd2ef8d9335a9dc30964.svg";